var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cell-content" }, [
    _c("span", { staticClass: "merge-status", class: _vm.statusClass }, [
      _vm._v(_vm._s(_vm.statusLabel)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }